// src/ones/OneChild.js
import { useContext } from "react";
import { AppContext } from "../App";
import { IoMdHeart, IoMdArrowForward } from "react-icons/io";

export default function OneChild({ 
  image, 
  name, 
  age, 
  medicalNeed, 
  status,
  navToLink = null 
}) {
  const appContext = useContext(AppContext);

  return (
    <div 
      className="card"
      style={{
        height: "420px",
        cursor: "pointer",
        backgroundImage: `url(${image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        overflow: "hidden",
        borderRadius: "12px",
        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
        transition: "transform 0.3s ease",
      }}
      onClick={() => {
        if (navToLink) {
          appContext.navTo(navToLink);
        } else {
          appContext.navTo({ item: 'donations' });
        }
      }}
    >

      <div
        style={{
          width: "100%",
          height: "100%",
          background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.65) 40%, transparent 100%)",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      />

      <div 
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "20px",
          color: "white",
        }}
      >
        <h5 className="font-bold mNoMargin" style={{ fontSize: "20px", lineHeight: 1.3 }}>
          {name}
        </h5>
        
        <div className="mt-2 d-flex flex-wrap gap-1">
          <span className="badge bg-primary" style={{ fontSize: "0.75rem" }}>
            {age} yrs
          </span>
          <span className="badge bg-success" style={{ fontSize: "0.75rem" }}>
            Tanzanian
          </span>
        </div>

        <div className="mt-2 d-flex align-items-center">
          <span 
            className="badge bg-warning text-dark d-flex align-items-center"
            style={{ 
              fontSize: "0.75rem",
              padding: "4px 8px"
            }}
          >
            <IoMdHeart size={12} className="me-1" />
            {status}
          </span>
        </div>
      </div>

      <button
        className="position-absolute text-primary"
        style={{
          top: "16px",
          right: "16px",
          background: "rgba(255,255,255,0.95)",
          border: "none",
          borderRadius: "30px",
          padding: "6px 16px",
          fontWeight: "600",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          cursor: "pointer",
          transition: "all 0.2s"
        }}
        onClick={() => {
          appContext.navTo({ item: 'donations' });
        }}
      >
        <IoMdHeart size={16} />
        Donate
        <IoMdArrowForward size={14} />
      </button>
    </div>
  );
}